import { Component, OnInit, AfterContentChecked, HostListener, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from './../../../../environments/environment';
import { CfetBaseComponent, CfetPageNamesConstant, CfetService } from '../../../cfet-core';

@Component({
    selector: 'app-utf-registration-verify',
    templateUrl: './utf-registration-verify.component.html',
    styleUrls: ['./utf-registration-verify.component.scss'],
    standalone: false
})
export class UtfRegistrationVerifyComponent extends CfetBaseComponent implements OnInit, AfterContentChecked {

  stepOneIcon = true;
  stepOneSelected = false;
  stepOneTickIcon = false;
  stepOneDone = false;
  stepTwoIcon = true;
  stepTwoSelected = true;
  stepTwoInformationpage: boolean;
  stepTwoProfileDone: boolean;
  stepTwoDone = false;
  disableStep = true;
  showHeading = true;
  showEligibilitySection = true;
  showInfoSection = false;
  showStepCompleteHeading = false;
  signupCompleted = false;
  selectedRole: any;
  selectedWorkPlace: any;
  selectedAddress: any;
  selectedCity: any;
  selectedStateInWorkplace: any;
  selectedZipInWorkplace: any;
  divHeight1: number;
  divHeight2: number;
  eligibilitystoredInfo: any;
  openInactivityModal = '';
  showInactivityModal = true;
  countDown: any;
  checkTimeout = true;
  openCancelModal = '';
  showCancelModal = false;
  progressTrackerStatus: any = 'registration';

  constructor(private title: Title,
    private elementRef: ElementRef,
    private cfetService: CfetService) { super(); }

  ngOnInit () {
    this.title.setTitle(this.cfetTitles.information.utfHtmlTitle);
    this.cfetService.isLandingPage.next(false);
    this.stepTwoInformationpage = false;
    if (sessionStorage.getItem('eligibilityInfo') && Object.keys(sessionStorage.getItem('eligibilityInfo')).length !== 0) {
      this.stepOneDone = true;
      this.signupCompleted = true;
      this.disableStep = false;
      this.eligibilitystoredInfo = JSON.parse(sessionStorage.getItem('eligibilityInfo'));
      this.selectedRole = this.eligibilitystoredInfo['selectedRole'];
      this.selectedWorkPlace = this.eligibilitystoredInfo['eligibilityStatus'].selectedName;
      this.selectedAddress = this.eligibilitystoredInfo['eligibilityStatus'].selectedAddress;
      this.selectedCity = this.eligibilitystoredInfo['eligibilityStatus'].selectedCity;
      this.selectedStateInWorkplace = this.eligibilitystoredInfo['eligibilityStatus'].selectedStateInWorkplace.split(':')[0];
      this.selectedZipInWorkplace = this.eligibilitystoredInfo['eligibilityStatus'].selectedZipInWorkplace;
    }
    if (environment.enableUTFSessionTimeout && this.checkTimeout) {
      this.checkInactivity();
    }
  }

  ngAfterContentChecked () {
    this.divheightCalc();
  }

  handleProgressTrackerEvent (event) {
    this.progressTrackerStatus = event;
  }

  divheightCalc () {
    const divElem2 = this.elementRef.nativeElement.querySelector('#form-component-section');
    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    if (screen.width > 1024) {
      if (divElem2.scrollHeight > (93.4 * vh / 100)) {
        this.divHeight1 = divElem2.scrollHeight;
      } else {
        this.divHeight1 = 93.4 * vh / 100;
        this.divHeight2 = 93.4 * vh / 100;
      }
    }
  }

  goToInstantVerification1 (event) {
    if (event) {
      this.stepTwoProfileDone = true;
    }
  }

  clearTimeout (event) {
    if (event) {
      clearInterval(this.countDown);
    }
  }

  closeInactivityModal (event) {
    if (event === 'modalClose') {
      clearInterval(this.countDown);
      this.openInactivityModal = 'close';
    }
  }

  @HostListener('window:load')
  @HostListener('document:mousemove')
  @HostListener('document:keyup')
  @HostListener('document:click')
  @HostListener('window:scroll')
  @HostListener('document:touchstart', ['$event']) onMove ($event?: any) {
    if (environment.enableUTFSessionTimeout && this.checkTimeout && this.openInactivityModal !== 'open') {
      clearInterval(this.countDown);
      this.checkInactivity();
    }
  }

  openCancelModalIfTimeDiffLessThan30Secs (timeDiff) {
    if (timeDiff < 30000 && timeDiff > 0) {
      setTimeout(() => {
        this.openInactivityModal = 'open';
      });
      this.showCancelModal = false;
    }
  }

  checkInactivity () {
    const counterDownDate = new Date().getTime() + 330000;
    this.countDown = setInterval(() => {
      const currentTimeStamp = new Date().getTime();
      const timeDiffCount = counterDownDate - currentTimeStamp;
      this.openCancelModalIfTimeDiffLessThan30Secs(timeDiffCount);
      if (timeDiffCount < 0) {
        clearInterval(this.countDown);
        setTimeout(() => {
          this.openInactivityModal = 'close';
        });
        this.setReturnURLToSessionStorage();
        sessionStorage.setItem('fnStatus', 'fnStatus=ineligible');
        window.location.href = CfetPageNamesConstant.SESSION_TIME_OUT_UTF;
      }
    }, 350);
  }

  setReturnURLToSessionStorage () {
    let returnUrl = '';
    if (sessionStorage.getItem('returnUrl') && Object.keys(sessionStorage.getItem('returnUrl').length !== 0)) {
      returnUrl = sessionStorage.getItem('returnUrl');
    }
    sessionStorage.clear();
    if (returnUrl !== '') {
      sessionStorage.setItem('returnUrl', returnUrl);
    }
  }

  cancelModal (event) {
    if (event) {
      this.showCancelModal = true;
      this.openCancelModal = 'open';
    }
  }

  closeModal (event) {
    if (event === 'modalClose') {
      this.openCancelModal = 'close';
    }
  }

}
